// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-reacttooltip-clickable {\n  cursor: pointer;\n}\n\n.widget-reacttooltip {\n  display: inline-block;\n}\n\n.widget-reacttooltip.badge:empty {\n  display: initial;\n  /* Fix padding to stay round */\n  padding: 3px 10px;\n}\n\n.widget-reacttooltip.label:empty {\n  display: initial;\n  /* Fix padding to stay square */\n  padding: 0.2em 0.8em 0.3em;\n}\n\n.widget-reacttooltip.badge {\n  min-width: 18px;\n  min-height: 18px;\n}", ""]);
// Exports
module.exports = exports;
